import { AxiosError, AxiosResponse } from 'axios';

export default class AxiosUtils {
    static isErrorNotFound(err: AxiosError | null): boolean {
        if (!err || !err.response) {
            return false;
        }

        return AxiosUtils.isNotFound(err.response);
    }

    static isNotFound(res: AxiosResponse | number) {
        return AxiosUtils.isResponseOfCode(res, 404);
    }

    static isResponseOfCode(res: AxiosResponse | number, code: number) {
        const status = typeof res === 'number' ? res : res.status;
        return status === code;
    }
}
